import type { RouteLocationNormalizedLoadedGeneric } from 'vue-router'

export const getNestedRoutes = (
  route: RouteLocationNormalizedLoadedGeneric
) => {
  for (const key in getPagePath) {
    if (getPagePath[key][route.params.locale as string] === route.path) {
      const localeNew = route.params.locale === 'de' ? 'en' : 'de'
      const elements = getPagePath[key][localeNew].split('/')
      if (elements[3]) {
        return `/${elements.slice(3).join('/')}`
      }
    }
  }

  return ''
}
